import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterLinkSnackBarConfig} from '@aviary/store/snack-bar/snack-bar.types';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';
import {AviaryButtonRouteNameDirective} from '@aviary/buttons/base/aviary-button-route-name.directive';

@Component({
  selector: 'mx-router-link-snack-bar',
  template: `
    @if (config.beforeLinkText; as beforeText) {
      <span>{{ beforeText }}</span>&ngsp;
    }

    <mx-link-button [label]="config.linkText" labelClasses="text-label-large uppercase" linkType="inline" [aviaryRouteName]="config.routeName"
                    [routeParams]="config.routeParams ?? {}" [queryParams]="config.queryParams" (click)="onClickRouterLink()"/>

    @if (config.afterLinkText; as afterText) {
      &ngsp;<span>{{ afterText }}</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LinkButtonComponent, AviaryButtonRouteNameDirective]
})
export class RouterLinkSnackBarComponent {

  public config: RouterLinkSnackBarConfig = inject(MAT_SNACK_BAR_DATA);

  private snackBarRef: MatSnackBarRef<RouterLinkSnackBarComponent> = inject(MatSnackBarRef);

  public onClickRouterLink(): void {
    // Once the user has clicked the link, they are navigating away.  The snack bar has now served its purpose, so we cen dismiss it early.
    this.snackBarRef.dismiss();
  }
}
